<label [for]="inputId" class="visually-hidden" *ngIf="useScreenReaderLabel || screenReaderLabel">
  {{ screenReaderLabel || placeholder }}
</label>
<input
  [type]="type"
  class="form-control"
  #inputRef
  [name]="name"
  [id]="inputId"
  [formControl]="control"
  [placeholder]="placeholder"
  [value]="value"
  [attr.min]="min ? min : null"
  [attr.max]="max ? max : null"
  [attr.maxlength]="maxlength"
  [pattern]="pattern"
  [readonly]="readonly"
  [autocomplete]="autocompleteValue"
  [ngClass]="inputClasses"
  [attr.aria-label]="ariaLabel ? ariaLabel : null"
/>
